var React = require('react');

function Suitcase (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24.25 18.25H35.75V22.25H40.75V38.75H19.25V22.25H24.25V18.25ZM25.75 22.25H34.25V19.75H25.75V22.25ZM20.75 23.75V28.75H39.25V23.75H20.75ZM39.25 30.25H32.75V32.75H27.25V30.25H20.75V37.25H39.25V30.25ZM28.75 30.25V31.25H31.25V30.25H28.75Z","fill":"#2E2B26","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"59","height":"59","stroke":"#C3C2C1","key":1})]);
}

Suitcase.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Suitcase;

Suitcase.default = Suitcase;
